import '../list/gb-list.tag.html';
import { RelatedQueries } from './gb-related-queries';
riot.tag2('gb-related-queries', '<yield> <gb-list class="{_style}" items="{relatedQueries}" scope="gb-related-queries" inline> <a onclick="{_scope.send}">{item}</a> </gb-list> </yield>', '', '', function(opts) {
    this._mixin(RelatedQueries);
});



/** WEBPACK FOOTER **
 ** ./src/tags/related-queries/gb-related-queries.tag.html
 **/